const ServiceCategoryTypeEnum = {
  Web: {
    value: 1
  },
  WordAddin: {
    value: 2
  },
  LecheckManagment: {
    value: 100
  }
};

export default ServiceCategoryTypeEnum;



// WEBPACK FOOTER //
// ./src/constants/common/service_category_type.js